<div class="window-content">
  <prime-user-recent-projects
    [recentProjects]="projects"
    (projectSelected)="goToProject($event)"
  ></prime-user-recent-projects>
</div>
